import React from 'react';
import { CheckCircle2 } from 'lucide-react';

import { useIntake } from '../context/IntakeContext';
import ResumeLinkPanel from '../components/ResumeLinkPanel';

/**
 * Confirmation, and nothing else.
 *
 * Coming back to add photos is still a normal thing to want (scenario 9), but
 * the acknowledgement email now carries the link — so this page says the
 * request has landed and stops. A customer who has just finished a form does
 * not want to be handed another job, and the link is safer in an inbox than on
 * a screen that will be closed in a few seconds.
 *
 * The one exception is an email that did not go out. Then this page is the only
 * route back to the request, and the panel returns.
 */
const DoneStep = () => {
  const { organisation, form, delivery } = useIntake();
  const shop = organisation?.name || 'The repairer';

  // Null means this browser didn't submit — a reload, or an old link. Assume
  // the email was sent rather than showing a resume panel to someone who is
  // simply revisiting the page.
  const emailed = delivery === null || delivery.emailSent;

  return (
    <div className="flex flex-col gap-6 py-6">
      <div className="flex flex-col items-center gap-3 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-green-100 text-green-700">
          <CheckCircle2 className="h-7 w-7" />
        </span>
        <h1 className="text-2xl font-semibold tracking-tight">Request sent</h1>
        <p className="text-sm text-muted-foreground">
          {shop} will be in touch.
        </p>
        {emailed && (
          <p className="text-sm text-muted-foreground">
            We've sent a confirmation email to {form.email ? <span className="font-medium text-foreground">{form.email}</span> : 'you'} with a link if you need to add photos or change anything.
          </p>
        )}
      </div>

      {!emailed && <ResumeLinkPanel title="Keep this link to add photos later" />}
    </div>
  );
};

export default DoneStep;
